
import { Component, Mixins, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import * as modals from "@/lib/modals";
import { ConsolidateLoadsRequest } from "../../../models/api/barcodeSystem/loads/consolidate";
import notifications from "@/lib/notifications";

@Component({
  name: modals.consolidateLoadsModal
})
export default class ConsolidateLoadsModal extends Mixins(mixin) {
  loadModule: LoadModule = getModule(LoadModule);
  consolidatedLoadName: string = "";
  billToCompanyId: string = "";
  facilityCode: string = "";
  isValid: boolean = false;
  isInvalid: boolean = false;

  load() {
    if(this.selectedItems && this.selectedItems.length > 1)
    {
      this.billToCompanyId = this.selectedItems[0].billToCompanyId;
      this.facilityCode = this.selectedItems[0].facilityCode;
      this.isInvalid = this.selectedItems.some(x => x.billToCompanyId != this.billToCompanyId || x.facilityCode != this.facilityCode );
      this.isValid = !this.isInvalid;
    }
  }

  unload() {
    this.isInvalid = false;
    this.isInvalid = false;
    this.billToCompanyId = "";
    this.facilityCode = "";
    this.consolidatedLoadName = "";
  }

  async consolidate() {
    this.isLoading = true;
    let request = {
      facilityCode: this.facilityCode,
      billToCompanyId: this.billToCompanyId,
      loadIds: this.selectedItems.map(x => x.id),
      consolidatedLoadName: this.consolidatedLoadName
    } as ConsolidateLoadsRequest


    try {
      await this.loadModule.consolidateLoads(request);
      notifications.success("Loads Combined", "Loads successfully combined.");    
      await this.refreshLoads();
      this.hideModal();
    } catch (error) {
      this.isLoading = false;
      notifications.error(
          "Loads Combining Failed",
          error.response.data.message
        );
    }
  }

  async refreshLoads(){
    await this.loadModule.updateLoadsAfterAction(this.selectedItems);
  }
}
